/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerModerateMutationRequest,
  TelegramProductsModeratorControllerModerateMutationResponse,
  TelegramProductsModeratorControllerModeratePathParams,
  TelegramProductsModeratorControllerModerate401,
  TelegramProductsModeratorControllerModerate404,
} from '../../types/TelegramProductsModeratorControllerModerate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorModerate } from '../../methods/telegramProductsModeratorModerate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorModerateMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/moderate/:id' }] as const;

export type TelegramProductsModeratorModerateMutationKey = ReturnType<
  typeof telegramProductsModeratorModerateMutationKey
>;

/**
 * {@link /api/moderator/telegram/products/moderate/:id}
 */
export function useTelegramProductsModeratorModerate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerModerateMutationResponse,
      ResponseErrorConfig<
        TelegramProductsModeratorControllerModerate401 | TelegramProductsModeratorControllerModerate404
      >,
      {
        id: TelegramProductsModeratorControllerModeratePathParams['id'];
        data: TelegramProductsModeratorControllerModerateMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsModeratorControllerModerateMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorModerateMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerModerateMutationResponse,
    ResponseErrorConfig<
      TelegramProductsModeratorControllerModerate401 | TelegramProductsModeratorControllerModerate404
    >,
    {
      id: TelegramProductsModeratorControllerModeratePathParams['id'];
      data: TelegramProductsModeratorControllerModerateMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return telegramProductsModeratorModerate(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
